export const getCapitalizeFirstLetter = (value = "") => {
  const formatValue = value
    ? `${value.charAt(0).toUpperCase()}${value.slice(1)}`
    : null;
  return formatValue;
};
